import { useUser } from "../../../misc/Permission";
const productReviewEmailWhitelist = ["tyler@tykel.ca", "system@admin.com", "nbosscher@blue-giraffe.ca"];
export function useCanReviewProducts() { const usr = useUser(); if (!usr)
    return null; return productReviewEmailWhitelist.includes(usr.email); }
